import { ArrowDown } from "lucide-react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/a00d980c-9fe5-42b7-a3dd-4077b0a743e8/images/167e365ff06dcf5d83fd506c30c0730729f58c70e0de034ca0de421c3abc8391.png";

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden blueprint-grid"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Engineering circuitry backdrop"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/60 via-[#050505]/40 to-[#050505]" />
      </div>

      {/* Top corner brackets */}
      <div className="absolute top-24 left-6 md:left-12 lg:left-16 font-mono-accent text-[10px] tracking-[0.3em] text-white/40 uppercase reveal">
        <div>LAT 44.97°N</div>
        <div>LNG -93.26°W</div>
        <div className="mt-2 text-[#00F0FF]">SYS / ONLINE<span className="blink">_</span></div>
      </div>
      <div className="absolute top-24 right-6 md:right-12 lg:right-16 font-mono-accent text-[10px] tracking-[0.3em] text-white/40 uppercase text-right reveal reveal-d1">
        <div>PORTFOLIO V.01</div>
        <div>HS / 2024 — 2026</div>
        <div className="mt-2 text-white">3 PROJECTS / 3 CONTINENTS</div>
      </div>

      {/* Main content */}
      <div className="relative z-10 flex flex-col justify-center min-h-screen px-6 md:px-12 lg:px-16 pt-32 pb-20">
        <div className="reveal reveal-d1">
          <span className="font-mono-accent text-xs tracking-[0.35em] uppercase text-[#FF3B30]">
            // Engineering Portfolio
          </span>
        </div>

        <h1
          data-testid="hero-name"
          className="reveal reveal-d2 font-display font-black uppercase mt-6 leading-[0.85] text-[14vw] md:text-[11vw] lg:text-[9.5vw]"
        >
          Noah
          <br />
          <span className="text-outline">Burgmaier</span>
        </h1>

        <div className="reveal reveal-d3 mt-10 grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 items-end">
          <div className="md:col-span-6">
            <p className="font-body text-base md:text-lg text-white/70 leading-relaxed max-w-lg">
              Mechanical Team Lead at <span className="text-white font-semibold">BSM Robotics</span> — the only high school program in the world competing in RoboCupRescue against college and university teams. Two international campaigns, one custom electric longboard, and a high school career spent chasing tolerances down to the millimeter.
            </p>
          </div>
          <div className="md:col-span-3 md:col-start-8">
            <div className="border-l border-white/15 pl-5">
              <div className="font-mono-accent text-[10px] tracking-[0.25em] text-white/40 uppercase">
                Role
              </div>
              <div className="font-display text-xl mt-1 font-bold">
                Mechanical Lead
              </div>
            </div>
          </div>
          <div className="md:col-span-3">
            <div className="border-l border-white/15 pl-5">
              <div className="font-mono-accent text-[10px] tracking-[0.25em] text-white/40 uppercase">
                Currently
              </div>
              <div className="font-display text-xl mt-1 font-bold">
                Prepping <span className="text-[#FF3B30]">RoboCup KR</span>
              </div>
            </div>
          </div>
        </div>

        {/* CTA row */}
        <div className="reveal reveal-d4 mt-14 flex flex-wrap items-center gap-4">
          <a
            data-testid="hero-cta-projects"
            href="#robocup-brazil"
            className="group inline-flex items-center gap-3 bg-white text-black font-mono-accent text-[11px] tracking-[0.3em] uppercase px-7 py-4 hover:bg-[#FF3B30] hover:text-white transition-colors"
          >
            View Projects
            <ArrowDown size={14} className="group-hover:translate-y-0.5 transition-transform" />
          </a>
          <a
            data-testid="hero-cta-contact"
            href="#contact"
            className="inline-flex items-center gap-3 border border-white/20 text-white font-mono-accent text-[11px] tracking-[0.3em] uppercase px-7 py-4 hover:border-white hover:bg-white/5 transition-colors"
          >
            Contact
          </a>
        </div>
      </div>

      {/* Bottom marquee strip */}
      <div className="absolute bottom-0 left-0 right-0 border-t border-b border-white/10 bg-[#050505]/70 backdrop-blur-sm overflow-hidden py-4">
        <div className="marquee flex gap-12 font-mono-accent text-[11px] tracking-[0.3em] uppercase text-white/50">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="flex items-center gap-12 shrink-0">
              <span>RoboCup Brazil 2024-25</span>
              <span className="text-[#FF3B30]">●</span>
              <span>RoboCup South Korea 2025-26</span>
              <span className="text-[#FF3B30]">●</span>
              <span>Electric Longboard</span>
              <span className="text-[#FF3B30]">●</span>
              <span>Mechanical / Electrical / Embedded</span>
              <span className="text-[#FF3B30]">●</span>
              <span>Minneapolis, MN</span>
              <span className="text-[#FF3B30]">●</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
